export enum BADGE_STATUS_TYPE {
  DEFAULT = "default",
  SUCCESS = "success",
  ERROR = "error",
  WARN = "warn", // Legacy type
  WARNING = "warning",
  INFO = "info",
  VIOLET = "violet",
  ORANGE = "orange",
}
